import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useWorkspace } from '@/context/WorkspaceContext'
import { RemoteConfigContext } from '@/context/RemoteConfigContext'

export function SidebarMenu({ selectedMenu, setSelectedMenu }) {
  const { config } = useContext(RemoteConfigContext)
  const { isPartner, isSlackConnected } = useWorkspace()

  return (
    <div className="ml-[32px]">
      <button onClick={() => setSelectedMenu('home-new')} className="mt-16 flex items-center">
        <svg width="20" height="20" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.22221 11.4999H1L10.9999 1.5L20.9999 11.4999H18.7777"
            stroke={selectedMenu !== 'home-new' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'home-new' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M3.22266 11.5V19.2777C3.22266 19.8671 3.45678 20.4323 3.87353 20.8491C4.29027 21.2658 4.8555 21.4999 5.44486 21.4999H16.5559C17.1453 21.4999 17.7105 21.2658 18.1272 20.8491C18.544 20.4323 18.7781 19.8671 18.7781 19.2777V11.5"
            stroke={selectedMenu !== 'home-new' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'home-new' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M7.66602 21.5002V14.8335C7.66602 14.2442 7.90014 13.6789 8.31689 13.2622C8.73363 12.8455 9.29886 12.6113 9.88822 12.6113H12.1104C12.6998 12.6113 13.265 12.8455 13.6818 13.2622C14.0985 13.6789 14.3326 14.2442 14.3326 14.8335V21.5002"
            stroke={selectedMenu !== 'home-new' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'home-new' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
        </svg>
        {selectedMenu !== 'home-new' ? (
          <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">Home</p>
        ) : (
          <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">Home</p>
        )}
      </button>

      {/* Temporarily commented out Old Home button
      <button onClick={() => setSelectedMenu('home')} className="mt-4 flex items-center">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M5.83333 2.5V4.16667C5.83333 4.34348 5.90357 4.51295 6.0286 4.63797C6.15362 4.763 6.32309 4.83333 6.5 4.83333H13.5C13.6768 4.83333 13.8463 4.763 13.9713 4.63797C14.0963 4.51295 14.1667 4.34348 14.1667 4.16667V2.5"
            stroke={selectedMenu !== 'home' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="dark:stroke-gray-400 dark:stroke-[#FF4A8E]:last"
          />
          <path
            d="M5.83333 17.5V15.8333C5.83333 15.6565 5.90357 15.4871 6.0286 15.362C6.15362 15.237 6.32309 15.1667 6.5 15.1667H13.5C13.6768 15.1667 13.8463 15.237 13.9713 15.362C14.0963 15.4871 14.1667 15.6565 14.1667 15.8333V17.5"
            stroke={selectedMenu !== 'home' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="dark:stroke-gray-400 dark:stroke-[#FF4A8E]:last"
          />
          <path
            d="M10 4.83333V15.1667"
            stroke={selectedMenu !== 'home' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="dark:stroke-gray-400 dark:stroke-[#FF4A8E]:last"
          />
          <path
            d="M7.5 4.83333L10 8.33333L12.5 4.83333"
            stroke={selectedMenu !== 'home' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="dark:stroke-gray-400 dark:stroke-[#FF4A8E]:last"
          />
          <path
            d="M7.5 15.1667L10 11.6667L12.5 15.1667"
            stroke={selectedMenu !== 'home' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="dark:stroke-gray-400 dark:stroke-[#FF4A8E]:last"
          />
        </svg>
        {selectedMenu !== 'home' ? (
          <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">OLD Home</p>
        ) : (
          <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">OLD Home</p>
        )}
      </button>
      */}

      {/* Only show Roadmap button for partner workspaces */}
      {config.roadmap && isPartner && (
        <button onClick={() => setSelectedMenu('roadmap')} className="mt-6 flex items-center">
          <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2.5 16.3327C2.5 16.7747 2.67559 17.1986 2.98816 17.5112C3.30072 17.8238 3.72464 17.9993 4.16667 17.9993C4.60869 17.9993 5.03262 17.8238 5.34518 17.5112C5.65774 17.1986 5.83333 16.7747 5.83333 16.3327C5.83333 15.8907 5.65774 15.4667 5.34518 15.1542C5.03262 14.8416 4.60869 14.666 4.16667 14.666C3.72464 14.666 3.30072 14.8416 2.98816 15.1542C2.67559 15.4667 2.5 15.8907 2.5 16.3327Z"
              stroke={selectedMenu !== 'roadmap' ? '#62718D' : '#FF4A8E'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={selectedMenu === 'roadmap' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
            />
            <path
              d="M15.8327 6.33333C16.2747 6.33333 16.6986 6.15774 17.0112 5.84518C17.3238 5.53262 17.4993 5.10869 17.4993 4.66667C17.4993 4.22464 17.3238 3.80072 17.0112 3.48816C16.6986 3.17559 16.2747 3 15.8327 3C15.3907 3 14.9667 3.17559 14.6542 3.48816C14.3416 3.80072 14.166 4.22464 14.166 4.66667C14.166 5.10869 14.3416 5.53262 14.6542 5.84518C14.9667 6.15774 15.3907 6.33333 15.8327 6.33333Z"
              stroke={selectedMenu !== 'roadmap' ? '#62718D' : '#FF4A8E'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={selectedMenu === 'roadmap' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
            />
            <path
              d="M9.16602 16.3327H13.7493C14.5229 16.3327 15.2648 16.0254 15.8117 15.4784C16.3587 14.9314 16.666 14.1896 16.666 13.416C16.666 12.6425 16.3587 11.9006 15.8117 11.3536C15.2648 10.8066 14.5229 10.4993 13.7493 10.4993H7.08268C6.30913 10.4993 5.56727 10.1921 5.02029 9.64508C4.47331 9.0981 4.16602 8.35623 4.16602 7.58268C4.16602 6.80913 4.47331 6.06727 5.02029 5.52029C5.56727 4.97331 6.30913 4.66602 7.08268 4.66602H10.8327"
              stroke={selectedMenu !== 'roadmap' ? '#62718D' : '#FF4A8E'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={selectedMenu === 'roadmap' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
            />
          </svg>
          {selectedMenu !== 'roadmap' ? (
            <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">Suggestions</p>
          ) : (
            <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">Suggestions</p>
          )}
        </button>
      )}

      <button onClick={() => setSelectedMenu('products')} className="mt-6 flex items-center">
        <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_8317_68355)">
          <path d="M10.5556 2.5L18.1111 6.75V15.25L10.5556 19.5L3 15.25V6.75L10.5556 2.5Z" stroke={selectedMenu !== 'products' ? '#62718D' : '#FF4A8E'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={selectedMenu === 'products' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}/>
          <path d="M10.5566 11L18.1122 6.75" stroke={selectedMenu !== 'products' ? '#62718D' : '#FF4A8E'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={selectedMenu === 'products' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}/>
          <path d="M10.5566 11V19.5" stroke={selectedMenu !== 'products' ? '#62718D' : '#FF4A8E'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={selectedMenu === 'products' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}/>
          <path d="M10.5556 11L3 6.75" stroke={selectedMenu !== 'products' ? '#62718D' : '#FF4A8E'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={selectedMenu === 'products' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}/>
          <path d="M14.3329 4.625L6.77734 8.875" stroke={selectedMenu !== 'products' ? '#62718D' : '#FF4A8E'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className={selectedMenu === 'products' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}/>
          </g>
          <defs>
          <clipPath id="clip0_8317_68355">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)"/>
          </clipPath>
          </defs>
        </svg>
        {selectedMenu !== 'products' ? (
          <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">Products</p>
        ) : (
          <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">Products</p>
        )}
      </button>

      <button onClick={() => setSelectedMenu('projects')} className="mt-6 flex items-center">
        <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2 3H17.9994V14.25C17.9994 14.4489 17.9228 14.6397 17.7864 14.7803C17.65 14.921 17.465 15 17.2721 15H13.6359C13.443 15 13.2581 14.921 13.1217 14.7803C12.9853 14.6397 12.9087 14.4489 12.9087 14.25V12H7.09071V17.25C7.09071 17.4489 7.01409 17.6397 6.8777 17.7803C6.74132 17.921 6.55634 18 6.36346 18H2.72724C2.53437 18 2.34939 17.921 2.213 17.7803C2.07662 17.6397 2 17.4489 2 17.25V3Z"
            stroke={selectedMenu !== 'projects' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'projects' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M7.09071 9H2"
            stroke={selectedMenu !== 'projects' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'projects' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M7.08984 3V12"
            stroke={selectedMenu !== 'projects' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'projects' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M12.9102 9H18.0009"
            stroke={selectedMenu !== 'projects' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'projects' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M12.9102 3V12"
            stroke={selectedMenu !== 'projects' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'projects' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
        </svg>
        {selectedMenu !== 'projects' ? (
          <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">Projects</p>
        ) : (
          <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">Projects</p>
        )}
      </button>

      <button onClick={() => setSelectedMenu('meetings')} className="mt-6 flex items-center">
        <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13 8.00061L17.553 5.72461C17.7054 5.64844 17.8748 5.61249 18.045 5.62015C18.2152 5.62782 18.3806 5.67885 18.5256 5.76841C18.6706 5.85797 18.7902 5.98308 18.8733 6.13188C18.9563 6.28067 18.9999 6.44822 19 6.61861V13.3826C18.9999 13.553 18.9563 13.7205 18.8733 13.8693C18.7902 14.0181 18.6706 14.1432 18.5256 14.2328C18.3806 14.3224 18.2152 14.3734 18.045 14.3811C17.8748 14.3887 17.7054 14.3528 17.553 14.2766L13 12.0006V8.00061Z"
            stroke={selectedMenu !== 'meetings' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'meetings' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M1 6C1 5.46957 1.21071 4.96086 1.58579 4.58579C1.96086 4.21071 2.46957 4 3 4H11C11.5304 4 12.0391 4.21071 12.4142 4.58579C12.7893 4.96086 13 5.46957 13 6V14C13 14.5304 12.7893 15.0391 12.4142 15.4142C12.0391 15.7893 11.5304 16 11 16H3C2.46957 16 1.96086 15.7893 1.58579 15.4142C1.21071 15.0391 1 14.5304 1 14V6Z"
            stroke={selectedMenu !== 'meetings' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'meetings' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
        </svg>
        {selectedMenu !== 'meetings' ? (
          <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">Meetings</p>
        ) : (
          <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">Meetings</p>
        )}
      </button>

      <button onClick={() => setSelectedMenu('competitors')} className="mt-6 flex items-center">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.2963 3.64726C11.014 3.35645 10.8555 2.96201 10.8555 2.55073C10.8555 2.13945 11.014 1.74502 11.2963 1.4542C11.5785 1.16338 11.9614 1 12.3605 1C12.7597 1 13.1425 1.16338 13.4247 1.4542C13.707 1.74502 13.8656 2.13945 13.8656 2.55073C13.8656 2.96201 13.707 3.35645 13.4247 3.64726C13.1425 3.93808 12.7597 4.10146 12.3605 4.10146C11.9614 4.10146 11.5785 3.93808 11.2963 3.64726ZM9.19507 13.9158C9.42434 13.5708 9.33054 13.1053 8.98556 12.876C8.64059 12.6468 8.17507 12.7406 7.9458 13.0855L6.58759 15.1292L1.28065 13.2919C0.889226 13.1564 0.462064 13.3639 0.326552 13.7553C0.191041 14.1467 0.398496 14.5739 0.789916 14.7094L6.6455 16.7366C6.96853 16.8485 7.3263 16.7277 7.5155 16.443L9.19507 13.9158ZM9.85289 6.49702L8.79687 11.6112C8.72372 11.9655 8.91387 12.3215 9.249 12.4577L14.1014 14.4297L12.8238 18.2625C12.6928 18.6554 12.9052 19.0802 13.2981 19.2111C13.6911 19.3421 14.1158 19.1298 14.2468 18.7368L15.7468 14.2368C15.8719 13.8616 15.6841 13.4537 15.3177 13.3048L10.3921 11.3031L11.2521 7.13862L13.4716 10.0818C13.6531 10.3224 13.9609 10.431 14.2532 10.3576L18.7532 9.22703C19.1549 9.1261 19.3988 8.71862 19.2978 8.31689C19.1969 7.91516 18.7894 7.67131 18.3877 7.77224L14.3699 8.78165L11.4526 4.91328C11.3163 4.73256 11.1097 4.62724 10.8929 4.61586C10.7859 4.60995 10.6814 4.62724 10.5854 4.66394L4.32917 6.7895C4.1343 6.85571 3.9752 6.99908 3.88915 7.18604C3.80309 7.37299 3.79764 7.58709 3.87408 7.77818L4.87408 10.2782C5.02791 10.6628 5.46439 10.8498 5.84898 10.696C6.23357 10.5422 6.42063 10.1057 6.26679 9.72109L5.5605 7.95536L9.85289 6.49702Z"
            fill={selectedMenu !== 'competitors' ? '#62718D' : '#FF4A8E'}
            className={selectedMenu === 'competitors' ? 'dark:fill-[#FF4A8E]' : 'dark:fill-gray-400'}
          />
        </svg>
        {selectedMenu !== 'competitors' ? (
          <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">Competitors</p>
        ) : (
          <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">Competitors</p>
        )}
      </button>

      {isSlackConnected && (
        <button onClick={() => setSelectedMenu('chats')} className="mt-6 flex items-center">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_7229_53817)">
              <path
                d="M6.66602 7.5H13.3327"
                stroke={selectedMenu !== 'chats' ? '#62718D' : '#FF4A8E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={selectedMenu === 'chats' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
              />
              <path
                d="M6.66602 10.834H11.666"
                stroke={selectedMenu !== 'chats' ? '#62718D' : '#FF4A8E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={selectedMenu === 'chats' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
              />
              <path
                d="M15 3.33398C15.663 3.33398 16.2989 3.59738 16.7678 4.06622C17.2366 4.53506 17.5 5.17094 17.5 5.83398V12.5007C17.5 13.1637 17.2366 13.7996 16.7678 14.2684C16.2989 14.7373 15.663 15.0007 15 15.0007H10.8333L6.66667 17.5007V15.0007H5C4.33696 15.0007 3.70107 14.7373 3.23223 14.2684C2.76339 13.7996 2.5 13.1637 2.5 12.5007V5.83398C2.5 5.17094 2.76339 4.53506 3.23223 4.06622C3.70107 3.59738 4.33696 3.33398 5 3.33398H15Z"
                stroke={selectedMenu !== 'chats' ? '#62718D' : '#FF4A8E'}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className={selectedMenu === 'chats' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
              />
            </g>
            <defs>
              <clipPath id="clip0_7229_53817">
                <rect width="20" height="20" fill="white" />
              </clipPath>
            </defs>
          </svg>

          {selectedMenu !== 'chats' ? (
            <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">Chats</p>
          ) : (
            <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">Chats</p>
          )}
        </button>
      )}

      {/* Only show Recruiting button for partner workspaces */}
      {/* {isPartner && (
        <button onClick={() => setSelectedMenu('recruiting')} className="mt-6 flex items-center">
          <People
            className={cn('w-[23px] h-[23px]', selectedMenu !== 'recruiting' ? 'fill-slate' : 'fill-pink')}
            withFill={false}
          />
          <p
            className={cn(
              "text-base font-['Manrope'] mx-4",
              selectedMenu !== 'recruiting'
                ? 'text-slate font-medium leading-[23px]'
                : 'text-black font-semibold leading-tight'
            )}
          >
            Recruiting
          </p>
        </button>
      )} */}

      <button onClick={() => setSelectedMenu('integrations')} className="mt-6 flex items-center">
        <svg width="20" height="20" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.23189 4L18.5006 14.2687L15.9331 16.8362C15.2638 17.5323 14.4623 18.088 13.5757 18.4706C12.689 18.8533 11.7349 19.0552 10.7693 19.0647C9.80359 19.0742 8.84574 18.891 7.95173 18.5258C7.05773 18.1606 6.24554 17.6208 5.56268 16.9379C4.87982 16.2551 4.34 15.4429 3.97482 14.5489C3.60964 13.6549 3.42642 12.697 3.4359 11.7314C3.44537 10.7657 3.64734 9.81161 4.02998 8.92494C4.41263 8.03828 4.96827 7.23683 5.6644 6.56749L8.23189 4Z"
            stroke={selectedMenu !== 'integrations' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'integrations' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M1 21.5L5.37499 17.125"
            stroke={selectedMenu !== 'integrations' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'integrations' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M14.75 1.5L10.375 5.87499"
            stroke={selectedMenu !== 'integrations' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'integrations' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M21 7.75L16.625 12.125"
            stroke={selectedMenu !== 'integrations' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'integrations' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
        </svg>
        {selectedMenu !== 'integrations' ? (
          <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">Integrations</p>
        ) : (
          <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">Integrations</p>
        )}
      </button>

      <button onClick={() => setSelectedMenu('team')} className="mt-6 flex items-center">
        <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_2628_20999)">
            <path
              d="M4.16602 6.33333C4.16602 7.21739 4.5172 8.06523 5.14233 8.69036C5.76745 9.31548 6.61529 9.66667 7.49935 9.66667C8.3834 9.66667 9.23125 9.31548 9.85637 8.69036C10.4815 8.06523 10.8327 7.21739 10.8327 6.33333C10.8327 5.44928 10.4815 4.60143 9.85637 3.97631C9.23125 3.35119 8.3834 3 7.49935 3C6.61529 3 5.76745 3.35119 5.14233 3.97631C4.5172 4.60143 4.16602 5.44928 4.16602 6.33333Z"
              stroke={selectedMenu !== 'team' ? '#62718D' : '#FF4A8E'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={selectedMenu === 'team' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
            />
            <path
              d="M2.5 18V16.3333C2.5 15.4493 2.85119 14.6014 3.47631 13.9763C4.10143 13.3512 4.94928 13 5.83333 13H9.16667C10.0507 13 10.8986 13.3512 11.5237 13.9763C12.1488 14.6014 12.5 15.4493 12.5 16.3333V18"
              stroke={selectedMenu !== 'team' ? '#62718D' : '#FF4A8E'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={selectedMenu === 'team' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
            />
            <path
              d="M13.334 3.10742C14.051 3.29101 14.6865 3.70801 15.1403 4.29268C15.5942 4.87736 15.8405 5.59645 15.8405 6.33659C15.8405 7.07673 15.5942 7.79582 15.1403 8.3805C14.6865 8.96517 14.051 9.38217 13.334 9.56576"
              stroke={selectedMenu !== 'team' ? '#62718D' : '#FF4A8E'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={selectedMenu === 'team' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
            />
            <path
              d="M17.5 18V16.3333C17.4958 15.5976 17.2483 14.884 16.7961 14.3037C16.3439 13.7233 15.7124 13.3089 15 13.125"
              stroke={selectedMenu !== 'team' ? '#62718D' : '#FF4A8E'}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={selectedMenu === 'team' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
            />
          </g>
          <defs>
            <clipPath id="clip0_2628_20999">
              <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
            </clipPath>
          </defs>
        </svg>
        {selectedMenu !== 'team' ? (
          <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">Team</p>
        ) : (
          <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">Team</p>
        )}
      </button>

      <button onClick={() => setSelectedMenu('team-settings')} className="mt-6 flex items-center">
        <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M8.00008 4.66675H12.0001C12.1769 4.66675 12.3464 4.73699 12.4714 4.86201C12.5964 4.98704 12.6667 5.15651 12.6667 5.33341V6.00008C12.6667 6.79591 13.0179 7.55933 13.643 8.18445C14.2681 8.80958 15.0315 9.16675 15.8273 9.16675H16.4939C16.6709 9.16675 16.8403 9.23699 16.9654 9.36201C17.0904 9.48704 17.1606 9.65651 17.1606 9.83341V13.8334C17.1606 14.0103 17.0904 14.1798 16.9654 14.3048C16.8403 14.4298 16.6709 14.5001 16.4939 14.5001H15.8273C15.0315 14.5001 14.2681 14.8572 13.643 15.4824C13.0179 16.1075 12.6667 16.8709 12.6667 17.6667V18.3334C12.6667 18.5103 12.5964 18.6798 12.4714 18.8048C12.3464 18.9298 12.1769 19.0001 12.0001 19.0001H8.00008C7.82319 19.0001 7.65371 18.9298 7.52869 18.8048C7.40366 18.6798 7.33341 18.5103 7.33341 18.3334V17.6667C7.33341 16.8709 6.98222 16.1075 6.35709 15.4824C5.73196 14.8572 4.96855 14.5001 4.17271 14.5001H3.50608C3.32919 14.5001 3.15971 14.4298 3.03469 14.3048C2.90966 14.1798 2.83941 14.0103 2.83941 13.8334V9.83341C2.83941 9.65651 2.90966 9.48704 3.03469 9.36201C3.15971 9.23699 3.32919 9.16675 3.50608 9.16675H4.17271C4.96855 9.16675 5.73196 8.80958 6.35709 8.18445C6.98222 7.55933 7.33341 6.79591 7.33341 6.00008V5.33341C7.33341 5.15651 7.40366 4.98704 7.52869 4.86201C7.65371 4.73699 7.82319 4.66675 8.00008 4.66675Z"
            stroke={selectedMenu !== 'team-settings' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'team-settings' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
          <path
            d="M10 15.1666C11.3807 15.1666 12.5 14.0473 12.5 12.6666C12.5 11.2859 11.3807 10.1666 10 10.1666C8.61929 10.1666 7.5 11.2859 7.5 12.6666C7.5 14.0473 8.61929 15.1666 10 15.1666Z"
            stroke={selectedMenu !== 'team-settings' ? '#62718D' : '#FF4A8E'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={selectedMenu === 'team-settings' ? 'dark:stroke-[#FF4A8E]' : 'dark:stroke-gray-400'}
          />
        </svg>
        {selectedMenu !== 'team-settings' ? (
          <p className="text-slate dark:text-gray-400 text-base font-medium font-['Manrope'] leading-[23px] mx-4">Settings</p>
        ) : (
          <p className="text-black dark:text-white text-base font-semibold font-['Manrope'] leading-tight mx-4">Settings</p>
        )}
      </button>
    </div>
  )
}

SidebarMenu.propTypes = {
  selectedMenu: PropTypes.string.isRequired,
  setSelectedMenu: PropTypes.func.isRequired,
}
